import { inject, Injectable } from '@angular/core';
import {
  Auth,
  authState,
  createUserWithEmailAndPassword,
  GoogleAuthProvider,
  sendPasswordResetEmail,
  signInWithEmailAndPassword,
  signInWithPopup,
  signOut,
  updateProfile,
  User,
  user,
} from '@angular/fire/auth';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  private auth = inject(Auth);

  readonly user$: Observable<User | null> = user(this.auth);
  readonly authState$: Observable<User | null> = authState(this.auth);

  /**
   * Login with email and password
   * @param email The user's email
   * @param password The user's password
   */
  loginWithEmail(email: string, password: string) {
    return signInWithEmailAndPassword(this.auth, email, password);
  }

  /**
   * Login with Google
   */
  loginWithGoogle() {
    const provider = new GoogleAuthProvider();
    return signInWithPopup(this.auth, provider);
  }

  /**
   * Sign up with email and password
   * @param email The user's email
   * @param password The user's password
   */
  async signUpWithEmail(email: string, password: string, displayName: string) {
    try {
      const userCredential = await createUserWithEmailAndPassword(this.auth, email, password);
      await updateProfile(userCredential.user, { displayName });
      await userCredential.user.getIdToken(true);

      return userCredential;
    } catch (error) {
      console.error('Error en registro:', error);
      throw error;
    }
  }

  /**
   * Send password reset email
   * @param email The user's email
   */
  recoverPassword(email: string) {
    return sendPasswordResetEmail(this.auth, email);
  }

  /**
   * Logout the current user
   */
  logout() {
    return signOut(this.auth);
  }

  /**
   * Get the current user
   */
  getCurrentUser() {
    return this.auth.currentUser;
  }
}
